import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import clsx from 'clsx';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';
import SearchButton from '../../components/atoms/SearchButton';
// import ESSearchButton from '../../components/atoms/ESSearchButton';
import CsvDownloadButton from '../../components/atoms/CsvDownloadButton';
// import CsvDownloadEsButton from '../../components/atoms/CsvDownloadEsButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';
import DownloadCsvDialogConfirm from '../../components/molecules/DownloadCsvDialogConfirm';
import {
  getUpdateAmountHistoryList,
  downloadUpdateAmountHistoryList,
  GET_UPDATE_AMOUNT_HISTORY_LIST_SUCCESS,
  DOWNLOAD_UPDATE_AMOUNT_HISTORY_LIST_SUCCESS
} from '../../actions/Gochis';
import { getTextBySystem as gts } from '../../utils';
import UpdateAmountHistoryTableGroup from '../organisms/UpdateAmountHistoryTableGroup';

const styles = theme => ({
  root: {
    display: 'flex'
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar
  },
  content: {
    flexGrow: 1,
    padding: 40,
    paddingTop: 15,
    width: 'calc(100% - 240px)'
  },
  paperWhite: {
    padding: 20,
    marginBottom: 40
  },
  title: {
    color: '#000',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 15
  },
  subTitle: {
    fontWeight: '600',
    fontSize: 12,
    marginBottom: 10,
    color: '#000000'
  },
  rowForm: {
    display: 'flex',
    marginLeft: '-5px',
    marginRight: '-5px',
    flexWrap: 'wrap'
  },
  formControl: {
    paddingLeft: 5,
    paddingRight: 5,
    marginBottom: 15,
    width: '25%'
  },
  textField: {
    position: 'relative'
  },
  pageNButton: {
    display: 'flex',
    marginRight: '-5px',
    alignItems: 'center'
  },
  buttonRight: {
    marginLeft: 'auto'
  },
  textNoteClassicCsv: {
    fontSize: 12,
    width: 220,
    marginLeft: 'auto',
    textAlign: 'left',
    marginBottom: 10
  },
  textLinkCsv: {
    color: '#2196F3'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getUpdateAmountHistoryList,
          downloadUpdateAmountHistoryList
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('displayName', 'setDisplayName', ''),
  withState('shopName', 'setShopName', ''),
  withState('menuId', 'setMenuId', ''),
  withState('menuName', 'setMenuName', ''),
  withState('useDateFrom', 'setUseDateFrom', ''),
  withState('useDateTo', 'setUseDateTo', ''),
  withState('editedFrom', 'setEditedFrom', ''),
  withState('editedTo', 'setEditedTo', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 20),
  withState('shopId', 'setShopId', ''),
  withState('openPopupCsv', 'setOpenPopupCsv', false),
  withState('isZip', 'setIsZip', false),
  withState('updateAmountHistoryList', 'setUpdateAmountHistoryList', []),
  withState('updateAmountHistoryCount', 'setUpdateAmountHistoryCount', 0),
  withState('updateAmountHistoryLimit', 'setUpdateAmountHistoryLimit', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangeRowsPerPage: props => event => {
      props.setRowsPerPage(event.target.value);
    },
    handleChangePage: props => (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 20;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }
      const searchKey = {
        shopId: props.shopId,
        shopName: props.shopName,
        menuName: props.menuName,
        menuId: props.menuId,
        displayName: props.displayName,
        useDateFrom: props.useDateFrom,
        useDateTo: props.useDateTo,
        editedFrom: props.editedFrom,
        editedTo: props.editedTo,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions
        .getUpdateAmountHistoryList(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          if (data.type === GET_UPDATE_AMOUNT_HISTORY_LIST_SUCCESS) {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            props.updateOpenTable(true);
            props.setUpdateAmountHistoryList(data.payload.list);
            props.setUpdateAmountHistoryCount(data.payload.count);
            props.setUpdateAmountHistoryLimit(data.payload.limit);
          } else {
            props.setResultMessage('エラーが発生しました！');
            props.updateLoading(false);
          }
        })
        .catch(e => {
          console.log(e);
          props.updateOpenProgress(true);
          props.setResultMessage('エラーが発生しました！');
          props.updateLoading(false);
        });
      props.setPage(page);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.handleChangePage(null, 1, this.props.rowsPerPage);
    }
  })
);

const HomeGroup = enhance(
  ({
    classes,
    actions,
    checkSession,
    handleChangePage,
    handleChangeRowsPerPage,
    account,
    openTable,
    // updateOpenTable,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    shopName,
    setShopName,
    menuName,
    setMenuName,
    displayName,
    setDisplayName,
    useDateFrom,
    setUseDateFrom,
    useDateTo,
    setUseDateTo,
    editedFrom,
    setEditedFrom,
    editedTo,
    setEditedTo,
    page,
    shopId,
    setShopId,
    menuId,
    setMenuId,
    setPage,
    setRowsPerPage,
    openPopupCsv,
    setOpenPopupCsv,
    isZip,
    setIsZip,
    history,
    updateAmountHistoryList,
    updateAmountHistoryCount,
    updateAmountHistoryLimit
  }) => {
    const educateSystem =
      typeof account !== 'undefined' && account.educateSystem;

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limit = 20;
    if (rowsPerPage) {
      limit = rowsPerPage.textContent;
    }

    const searchKey = {
      shopName,
      menuName,
      displayName,
      useDateFrom,
      useDateTo,
      editedFrom,
      editedTo,
      shopId,
      menuId,
      limit
    };

    const searchAction = async () => {
      let limitNum = 20;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }
      updateLoading(true);
      updateOpenProgress(true);
      setPage(1);
      handleChangePage(null, 1, limitNum);
    };

    const downloadCsvBlob = (blob, fileName, isZipP) => {
      const blobC = new Blob([blob], {
        type: isZipP ? 'application/zip' : 'text/csv'
      });
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blobC, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(blobC);
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();

        linkEl.parentNode.removeChild(linkEl);
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const csvDownloadAction = async isZipP => {
      updateLoading(true);
      updateOpenProgress(true);
      let fileType = '';
      const params = { ...searchKey };
      if (isZipP) {
        params.isZip = 1;
        fileType = '.csv.zip';
      } else {
        params.isZip = 0;
        fileType = '.csv';
      }
      const response = await actions
        .downloadUpdateAmountHistoryList(params)
        .then(data => checkSession(data));

      if (response.type === DOWNLOAD_UPDATE_AMOUNT_HISTORY_LIST_SUCCESS) {
        const timeStamp = moment()
          .tz('Asia/Tokyo')
          .format('YYYYMMDDHHmm');
        updateOpenProgress(false);
        setResultMessage('');
        updateLoading(false);
        downloadCsvBlob(
          response.payload,
          `${timeStamp}_coupon_edit_history${fileType}`,
          isZipP
        );
      } else {
        setResultMessage(
          'ファイル容量が想定量を超えたため、ダウンロードに失敗しました。\n恐れ入りますが、期間を短く設定し直してから再度ダウンロードを実行ください。'
        );
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const cancelCsvAction = () => {
      setOpenPopupCsv(false);
      setIsZip(false);
    };

    const downloadCsvAction = () => {
      setOpenPopupCsv(false);
      csvDownloadAction(isZip);
    };

    return (
      <div className={classes.root}>
        <MenuDrawerGroup title="ごち情報" />
        <main className={classes.content}>
          <div className={classes.toolbar} style={{ display: 'none' }} />

          <Typography variant="h6" noWrap className={classes.title}>
            {'クーポン情報  > 金額修正履歴'}
          </Typography>
          <Paper className={classes.paperWhite}>
            <div className={classes.searchForm}>
              <div className={classes.rowForm}>
                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>教室ID</FormLabel>
                  <TextField
                    placeholder="例) 0123"
                    type="search"
                    className={classes.textField}
                    variant="outlined"
                    size="small"
                    value={shopId}
                    onChange={e => {
                      setShopId(e.target.value);
                    }}
                  />
                </FormControl>

                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>教室名</FormLabel>
                  <TextField
                    placeholder="例) Gigi〇〇校"
                    type="search"
                    className={classes.textField}
                    variant="outlined"
                    size="small"
                    value={shopName}
                    onChange={e => {
                      setShopName(e.target.value);
                    }}
                  />
                </FormControl>

                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>コース名</FormLabel>
                  <TextField
                    placeholder="例) Gigi〇〇コース"
                    type="search"
                    className={classes.textField}
                    variant="outlined"
                    size="small"
                    value={menuName}
                    onChange={e => {
                      setMenuName(e.target.value);
                    }}
                  />
                </FormControl>

                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>コースID</FormLabel>
                  <TextField
                    placeholder="例) 0123"
                    type="search"
                    className={classes.textField}
                    variant="outlined"
                    size="small"
                    value={menuId}
                    onChange={e => {
                      setMenuId(e.target.value);
                    }}
                  />
                </FormControl>
              </div>
              <div className={classes.rowForm}>
                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>利用者名</FormLabel>
                  <TextField
                    placeholder={gts('例) 東京都 1-2-3', educateSystem)}
                    type="search"
                    className={classes.textField}
                    variant="outlined"
                    size="small"
                    value={displayName}
                    onChange={e => {
                      setDisplayName(e.target.value);
                    }}
                  />
                </FormControl>
              </div>
              <div className={classes.rowForm}>
                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>
                    使用日(From)
                  </FormLabel>
                  <TextField
                    type="date"
                    className={classes.textField150}
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={useDateFrom}
                    onChange={e => {
                      setUseDateFrom(e.target.value);
                    }}
                    onBlur={e => {
                      if (!useDateFrom) {
                        e.target.value = '';
                        setUseDateFrom('');
                      }
                    }}
                  />
                </FormControl>

                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>使用日(To)</FormLabel>
                  <TextField
                    type="date"
                    className={classes.textField150}
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={useDateTo}
                    onChange={e => {
                      setUseDateTo(e.target.value);
                    }}
                    onBlur={e => {
                      if (!useDateTo) {
                        e.target.value = '';
                        setUseDateTo('');
                      }
                    }}
                  />
                </FormControl>

                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>
                    金額修正日(From)
                  </FormLabel>
                  <TextField
                    type="date"
                    className={classes.textField150}
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={editedFrom}
                    onChange={e => {
                      setEditedFrom(e.target.value);
                    }}
                    onBlur={e => {
                      if (!editedFrom) {
                        e.target.value = '';
                        setEditedFrom('');
                      }
                    }}
                  />
                </FormControl>

                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>
                    金額修正日(To)
                  </FormLabel>
                  <TextField
                    type="date"
                    className={classes.textField150}
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={editedTo}
                    onChange={e => {
                      setEditedTo(e.target.value);
                    }}
                    onBlur={e => {
                      if (!editedTo) {
                        e.target.value = '';
                        setEditedTo('');
                      }
                    }}
                  />
                </FormControl>
              </div>
            </div>
            <div className={classes.buttonLeft}>
              <SearchButton onClickAction={searchAction} />
            </div>
          </Paper>
          {openTable && (
            <div className={classes.pageNButton}>
              <div className={classes.pageLeft}>
                <ExPaginationGroup
                  count={
                    updateAmountHistoryCount % updateAmountHistoryLimit > 0
                      ? Math.floor(
                          updateAmountHistoryCount / updateAmountHistoryLimit
                        ) + 1
                      : Math.floor(
                          updateAmountHistoryCount / updateAmountHistoryLimit
                        )
                  }
                  selectedPage={page}
                  handleChangePage={(e, p, l) => handleChangePage(e, p, l)}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  limit={updateAmountHistoryLimit}
                  totalCount={updateAmountHistoryCount}
                  setLimit={setRowsPerPage}
                />
              </div>
              <div className={classes.buttonRight}>
                <Button
                  variant="outlined"
                  color="primary"
                  style={{ margin: '5px 5px' }}
                  onClick={() => {
                    history.push('/gochis_group');
                  }}
                >
                  クーポン情報管理に戻る
                </Button>
                <CsvDownloadButton
                  title="検索結果出力（CSV形式）"
                  onClickAction={() => {
                    setIsZip(false);
                    setOpenPopupCsv(true);
                  }}
                />
                <CsvDownloadButton
                  title="検索結果出力（ZIP形式）"
                  onClickAction={() => {
                    setIsZip(true);
                    setOpenPopupCsv(true);
                  }}
                />
                <div className={classes.textNoteClassicCsv}>
                  ※CSV形式でダウンロードができない場合はZIP形式をお試しください。
                  ZIP形式の説明は
                  <a
                    className={classes.textLinkCsv}
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://shop-guide.gochimeshi.com/group/p16179/"
                  >
                    こちら
                  </a>
                </div>
              </div>
            </div>
          )}
          {openTable && (
            <UpdateAmountHistoryTableGroup
              updateAmountHistoryList={updateAmountHistoryList}
            />
          )}

          {openTable && (
            <div className={classes.pageNButton}>
              <div className={classes.pageLeft}>
                <ExPaginationGroup
                  count={
                    updateAmountHistoryCount % updateAmountHistoryLimit > 0
                      ? Math.floor(
                          updateAmountHistoryCount / updateAmountHistoryLimit
                        ) + 1
                      : Math.floor(
                          updateAmountHistoryCount / updateAmountHistoryLimit
                        )
                  }
                  selectedPage={page}
                  handleChangePage={(e, p, l) => handleChangePage(e, p, l)}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  limit={updateAmountHistoryLimit}
                  totalCount={updateAmountHistoryCount}
                  setLimit={setRowsPerPage}
                />
              </div>
            </div>
          )}
        </main>
        <DownloadCsvDialogConfirm
          message="ダウンロード情報には個人情報が含まれますので、取扱いには十分留意してください"
          openChangeConfirm={openPopupCsv}
          updateOpenChangeConfirm={setOpenPopupCsv}
          cancelAction={cancelCsvAction}
          changeAction={downloadCsvAction}
        />
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(HomeGroup));
